module.exports = __webpack_public_path__ + "img/handee.1a691a00.svg";